import React from 'react';
import { useTranslation } from 'react-i18next';

import { RecursiveMenu } from '@uncinc/react-drupal-core';
import type { RecursiveMenuProps } from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/types';

import './style.scss';

type NavbarMenuProps = Omit<RecursiveMenuProps, 'className' | 'menuId' | 'bookId' | 'maxLevel' | 'navProps'>;

const NavbarMenu: React.FC<NavbarMenuProps> = (props) => {
  const { t } = useTranslation();

  return (
    <RecursiveMenu
      {...props}
      className="NavbarMenu"
      menuId="navbar"
      maxLevel={1}
      navProps={{ 'aria-label': t('nav.navbar') }}
    />
  );
};

export default NavbarMenu;
